import { Loader } from '@care/react-component-lib';
import { Box, Grid } from '@mui/material';

export const Loading = () => {
  return (
    <Grid container>
      <Box mx="auto" mt={2} mb={6} textAlign="center">
        <Loader message="Loading results" />
      </Box>
    </Grid>
  );
};
